 
export const state = {
  hospCode: '',
  deptCode: '',
  appointType: 1,
}

export type State={
  hospCode: String,
  deptCode: String,
  appointType: Number
}
